import { AMember, AMemberInfo, Material, MaterialInfo, defaultAMemberInfo, kind } from "./internalModules";
import {Scenario} from "./internalModules";
import {WallType} from "./internalModules";
import {WallTypeWindow} from './internalModules'
import {WallTypeCurtain} from './internalModules'
import {WallTypeRibbon} from './internalModules'
import { Dist } from "./Dist";
import {ScenarioRow} from "./internalModules";
import { saveAs } from 'file-saver'
import { getCurrentDateTimeAsString } from "./utility";
import {ALayer, buckets} from "./internalModules";
import {AssemblyHorizontal} from "./internalModules";
import { v4 as uuidv4 } from 'uuid'
import { update } from "plotly.js";

export type DataJSON = {
  projectName: string,
  materials: object[],
  members: object[],
  layers: object[],
  assemblies: object[],
  scenarios: object[],
}

export type AssemblyJSON = {
  className: string,
  guid: string,
  name: string,
  height: string,
  width: string,
  length: string,
  layers: ALayerJSON[], // Wall & HorizontalSolid bucket
  layersGlazed: ALayerJSON[], // Glazed bucket
  layersFraming: ALayerJSON[], // HorizontalFraming bucket
  layersColumn: ALayerJSON[], // Column bucket
  wwr: string,
}

export type MaterialJSON = {
  className: string,
  guid: string,
  category: string,
  name: string,
  source: string,
  gwpByArea: string,
  gwpByVolume: string,
  gwpByWeight: string,
  density: string,
  transparent: boolean,
  notes: string
}

export type MemberJSON = {
  guid: string
  kind: string
  name: string
  materialGuid: string
  depth: string //inches
  width: string //inches
  thickness: string //inches
  lip: string //inches
  webThickness: string //inches
  flangeThickness: string //inches
  area: string //square inches cross section
  weight: string //pounds per linear foot
  topFlute: string //inches
  bottomFlute: string //inches
  notes: string
}

type ALayerJSON = {
  kind: string,
  memberGuid: string,
  materialGuid: string,
  thickness: string,
  fillMaterialGuid: string,
  fillThickness: string,
  framedVSpacing: string,
  framedHSpacing: string,
  framedMembersTop: string,
  framedMembersBottom: string,
  framedMembersLeft: string,
  framedMembersRight: string,
  framingDirection: string,
  framingSpacing: string,
  columnHeightRef: string,
  columnHeightDim: string,
  notes: string,
}

type ScenarioJSON = {
  className: string,
  guid: string,
  name: string,
  rows: ScenarioRowJSON[],
  calcMethod: string,
  totalArea: string,
}

type ScenarioRowJSON = {
  className: string,
  guid: string,
  wTypeId: string,
  parentScenario: string,
  amount: string,
}


export class AppData {
  wallTypes: Map<string, WallType>
  members: Map<string, AMember>
  materials: Map<string, Material>
  scenarios: Map<string, Scenario>
  projectName: string
  constructor(){
    this.wallTypes = new Map<string, WallType>()
    this.members = new Map<string, AMember>()
    this.materials = new Map<string, Material>()
    this.scenarios = new Map<string, Scenario>()
    this.projectName = 'Example Project'
    //console.log(this)
  }

  // Create Methods --------------------

  createWallType(walltype: WallType): WallType{
    //check if exists
    if ( this.wallTypes.has(walltype.guid)) {
      //do nothing
    }
    else {
      if (walltype.name === '') {
        walltype.name = `Assembly ${appdata.wallTypes.size + 1}`
      }
      this.wallTypes.set(walltype.guid, walltype);
    }
    return walltype
  }

  /** duplicate the assembly by guid */
  createDuplicateAssembly(guid: string){
    const sourceAssembly = this.getWallType(guid)
    const sourceString = JSON.stringify(sourceAssembly)
    //console.log('sourceString', sourceString)
    const sourceJson: AssemblyJSON = JSON.parse(sourceString) as AssemblyJSON
    //console.log('sourceJson', sourceJson)
    let newAssembly = this.assemblyFromJSON(sourceJson)
    newAssembly.guid = uuidv4()
    newAssembly.name = sourceAssembly.name + ' Copy'
    //console.log(newAssembly)
    this.createWallType(newAssembly)
  }

  //method to create from json
  assemblyFromJSON(obj: AssemblyJSON): WallType{
    switch (obj.className) {
      case 'WallType':
        const wt = new WallType(Dist.feet(Number(obj.height)), Dist.feet(Number(obj.width)))
        wt.guid = obj.guid
        wt.name = obj.name
        for(const l of obj.layers){
          let layer = this.layerFromJSON(l)
          wt.layers.push(layer)
        }
        wt.calculateGwpSF()
        wt.regenGeometry()
        return wt

      case 'WallTypeRibbon':
        const wtr = new WallTypeRibbon(Dist.feet(Number(obj.height)), Dist.feet(Number(obj.width)), Number(obj.wwr))
        wtr.guid = obj.guid
        wtr.name = obj.name
        // wtr.layerIds = obj.layerIds
        for(const l of obj.layers){
          let layer = this.layerFromJSON(l)
          wtr.layers.push(layer)
        }
        // wtr.layerIdsGlazed = obj.layerIdsGlazed
        for(const l of obj.layersGlazed){
          let layer = this.layerFromJSON(l)
          wtr.layersGlazed.push(layer)
        }
        wtr.regenSubtypes()
        wtr.calculateGwpSF()
        wtr.regenGeometry()
        return wtr

      case 'WallTypeWindow':
        const wtw = new WallTypeWindow(Dist.feet(Number(obj.height)), Dist.feet(Number(obj.width)), Number(obj.wwr))
        wtw.guid = obj.guid
        wtw.name = obj.name
        // wtr.layerIds = obj.layerIds
        for(const l of obj.layers){
          let layer = this.layerFromJSON(l)
          wtw.layers.push(layer)
        }
        // wtr.layerIdsGlazed = obj.layerIdsGlazed
        for(const l of obj.layersGlazed){
          let layer = this.layerFromJSON(l)
          wtw.layersGlazed.push(layer)
        }
        wtw.regenSubtypes()
        wtw.calculateGwpSF()
        wtw.regenGeometry()
        return wtw

      case 'WallTypeCurtain':
        const wtc = new WallTypeCurtain(Dist.feet(Number(obj.height)), Dist.feet(Number(obj.width)), Number(obj.wwr))
        wtc.guid = obj.guid
        wtc.name = obj.name
        // wtr.layerIds = obj.layerIds
        for(const l of obj.layers){
          let layer = this.layerFromJSON(l)
          wtc.layers.push(layer)
        }
        // wtr.layerIdsGlazed = obj.layerIdsGlazed
        for(const l of obj.layersGlazed){
          let layer = this.layerFromJSON(l)
          wtc.layersGlazed.push(layer)
        }
        wtc.regenSubtypes()
        wtc.calculateGwpSF()
        wtc.regenGeometry()
        return wtc

      case 'AssemblyHorizontal':
        const ah = new AssemblyHorizontal(Dist.feet(Number(obj.height)),
          Dist.feet(Number(obj.width)),
          Dist.feet(Number(obj.length)))
        ah.guid = obj.guid
        ah.name = obj.name
        for(const l of obj.layers){
          let layer = this.layerFromJSON(l)
          ah.addLayer(buckets.hSolid,layer)
        }
        for(const l of obj.layersFraming){
          let layer = this.layerFromJSON(l)
          ah.addLayer(buckets.hFraming, layer)
        }
        for(const l of obj.layersColumn){
          let layer = this.layerFromJSON(l)
          ah.addLayer(buckets.column, layer)
        }
        ah.calculateGwpSF()
        ah.regenGeometry()
        return ah
    }
    return new WallType(Dist.feet(10), Dist.feet(10))
  }

  layerFromJSON(obj: ALayerJSON): ALayer {
    let layer = new ALayer()
    layer.kind = obj.kind
    layer.memberGuid = obj.memberGuid
    layer.materialGuid = obj.materialGuid
    layer.thickness = Dist.inches(Number(obj.thickness))
    layer.fillMaterialGuid = obj.fillMaterialGuid
    layer.fillThickness = Dist.inches(Number(obj.fillThickness))
    layer.framedVSpacing = Dist.inches(Number(obj.framedVSpacing))
    layer.framedHSpacing = Dist.inches(Number(obj.framedHSpacing))
    layer.framedMembersTop = Number(obj.framedMembersTop)
    layer.framedMembersBottom = Number(obj.framedMembersBottom)
    layer.framedMembersLeft = Number(obj.framedMembersLeft)
    layer.framedMembersRight = Number(obj.framedMembersRight)
    layer.framingDirection = obj.framingDirection
    layer.framingSpacing = Dist.inches(Number(obj.framingSpacing))
    layer.columnHeightRef = Number(obj.columnHeightRef)
    layer.columnHeightDim = Dist.inches(Number(obj.columnHeightDim))
    layer.notes = obj.notes
    return layer
  }

  createMember(member: AMember){
    //check if member exists
    if ( this.members.has(member.guid) /* || Array.from(this.members.values()).map( x => x.name ).includes(member.name) */ ) {
      //do nothing
      return
    }
    else {
      this.members.set(member.guid, member)
    }
  }

  memberFromJSON(obj: MemberJSON): AMember {
    let info: AMemberInfo = {...defaultAMemberInfo}
    info.guid = obj.guid
    info.kind = obj.kind
    info.name = obj.name
    info.materialGuid = obj.materialGuid
    info.depth = Number(obj.depth)
    info.width = Number(obj.width)
    info.thickness = Number(obj.thickness)
    info.lip = Number(obj.lip)
    info.webThickness = Number(obj.webThickness)
    info.flangeThickness = Number(obj.flangeThickness)
    info.area = Number(obj.area)
    info.weight = Number(obj.weight)
    info.topFlute = Number(obj.topFlute)
    info.bottomFlute = Number(obj.bottomFlute)
    info.notes = obj.notes
    return new AMember(info)
  }

  createMaterial(material: Material): Material {
    //check if material exists
    if ( this.materials.has(material.guid) ) {
      //do nothing
    }
    else {
      //add the material
      this.materials.set(material.guid, material);
    }
    return material
  }

  //method to create from json
  materialFromJSON(obj: MaterialJSON): Material {
    const material = new Material(
      obj.category,
      obj.name,
      obj.source,
      Number(obj.gwpByArea),
      Number(obj.gwpByVolume),
      Number(obj.gwpByWeight),
      Number(obj.density),
      obj.transparent,
      obj.notes
    )
    material.guid = obj.guid
    //console.log('createMaterialFromJSON:', material)
    return material
  }

  createScenario(scenario: Scenario){
    //check if exists
    if ( this.scenarios.has(scenario.guid)) {
      //do nothing
    }
    else {
      this.scenarios.set(scenario.guid, scenario);
    }
  }

  createScenarioFromJSON(obj: ScenarioJSON) {
    const scenario = new Scenario()
    scenario.guid = obj.guid
    scenario.rows = []
    for (const row of obj.rows) {
      const scenarioRow = new ScenarioRow(scenario)
      scenarioRow.guid = row.guid
      scenarioRow.wTypeId = row.wTypeId
      scenarioRow.amount = Number(row.amount)
      scenario.rows.push(scenarioRow)
    }
    if (scenario.rows.length < 1) {
      scenario.addRow()
    }
    scenario.calcMethod = obj.calcMethod
    scenario.totalArea = Number(obj.totalArea)
    this.createScenario(scenario)
  }

  createScenarioRowFromJSON(obj: ScenarioRowJSON, scenario: Scenario): ScenarioRow {
    const scenarioRow = new ScenarioRow(scenario)
    scenarioRow.guid = obj.guid
    scenarioRow.wTypeId = obj.wTypeId
    scenarioRow.amount = Number(obj.amount)
    return scenarioRow
  }


  // Read Methods ---------------------------
  
  getWallType(guid: string): WallType {
    let wType = this.wallTypes.get(guid);
    if (wType === undefined) {
      //console.log(`getWallType: guid was not found ${guid}`)
      return new WallType(Dist.zero, Dist.zero)
    }
    else {
      return wType;
    }
  }

  getWallTypeArray(): WallType[] {
    //if no assemblies, add new empty walltype
    if(this.wallTypes.size < 1){
      this.createWallType(new WallType(Dist.feet(8), Dist.feet(10)))
    }
    return Array.from(appdata.wallTypes.values());
  }

  getMember(guid: string | undefined): AMember {
    if (guid === undefined){
      return AMember.getEmpty();
    }
    else {
      for (let member of this.members.values()) {
        if (member instanceof AMember && member.guid === guid){
          return member;
        }
      }
      return AMember.getEmpty();
    }
  }

  /** Returns a list of members of the class name(s) provided in class filter, or all members if no filter provided.  */
  getMemberArray(memberKindFilter: string[] = [] ): AMember[] {
    let members = Array.from(appdata.members.values())
    if(memberKindFilter.length > 0){
      return members.filter(x => memberKindFilter.includes(x.kind))
    }
    else{
      return members
    }
  }

  /** Return array of layers from all assemblies in the specified bucket or return all layers if no bucket specified*/
  getUsedLayers(assembly: WallType, layerBucket?: string): ALayer[] {
    let allLayers: ALayer[] = []
    // collect all the layers from all buckets
    for (const assembly of this.getWallTypeArray()) {
      for (const buckt of Object.values(buckets)) {
        const bucktLayers = assembly.getLayers(buckt)
        if (bucktLayers.length > 0) {
          for (const lay of bucktLayers){
            allLayers.push(lay)
          }
        }
      }
    }
    
    // remove duplicates
    let distinctLayers: ALayer[] = []
    for (const lay of allLayers) {
      if ( distinctLayers.map(x=>x.name(assembly)).includes(lay.name(assembly))){
        continue
      }
      distinctLayers.push(lay)
    }
    distinctLayers.sort( (a, b) => a.name(assembly).localeCompare(b.name(assembly)))

    // filter the array for the kinds of layers allowed in the specified bucket
    if (layerBucket) {
      switch (layerBucket) {
        case buckets.wall: //only solid and framed layer kinds
          return distinctLayers.filter(x=> x.kind === kind.solid || x.kind === kind.framed)
        case buckets.glazed: //only solid and framed layer kinds
          return distinctLayers.filter(x=> x.kind === kind.solid || x.kind === kind.framed)
        case buckets.hFraming: //only framing
          return distinctLayers.filter(x=> x.kind === kind.framing)
        case buckets.hSolid: //only solid and metal deck
          return distinctLayers.filter(x=> x.kind === kind.solid || x.kind === kind.mDeck)
        case buckets.column: //only column
          return distinctLayers.filter(x=> x.kind === kind.column)
        default:
          break
      }
      return distinctLayers
    }
    return distinctLayers
  }

  getLayerBucketById(assembly: WallType, id: string): string {
    //iterate on the buckets, find layer with given id
    for (const bucket of Object.values(buckets)) {
      const layers = assembly.getLayers(bucket)
      if (layers.length > 0) {
        const layer = layers.filter(l=>l.id === id)[0]
        if (layer){
          return bucket
        }
      }
    }
    return ''
  }
    

  getMaterial(guidOrName: string | undefined): Material {
    if (guidOrName === undefined){
      //console.log(`getMaterial: guid or name was undefined`)
      return Material.getEmpty()
    }
    else {
      for (let material of this.materials.values()) {
        if (material instanceof Material && (material.guid === guidOrName || material.name === guidOrName)){
          return material;
        }
      }
      //console.log(`getMaterial: guid or name was not found ${guidOrName}`)
      return Material.getEmpty()
    }
  }

  getMaterialArray(): Material[] {
    return Array.from(appdata.materials.values())
  }

  getMaterialNames(): string[] {
    return Array.from(appdata.materials.values()).map( x => x.name)
  }

  getScenario(guid: string): Scenario {
    let foundScenario = this.scenarios.get(guid);
    if (foundScenario === undefined) {
      let newScenario = new Scenario();
      this.createScenario(newScenario)
      return newScenario;
    }
    else {
      return foundScenario;
    }
  }
 
  getScenarioArray(): Scenario[] {
    //if no scenarios, add one
    if (appdata.scenarios.size < 1){
      this.createScenario(new Scenario())
    }
    return Array.from(appdata.scenarios.values())
  }

  getScenarioBaseline(): Scenario {
    let baselineScenario = Array.from(this.scenarios.values()).filter(s => s.isBaseline === true)[0]
    if (baselineScenario) {
      return baselineScenario
    }
    //if no scenarios, add one
    if (appdata.scenarios.size < 1){
      this.createScenario(new Scenario())
    }
    //if no baseline found, set first scenario to baseline
    baselineScenario = Array.from(this.scenarios.values())[0]
    this.setScenarioAsBaseline(baselineScenario.guid)
    return baselineScenario
  }

  // Update Methods? -------------------------

  setScenarioAsBaseline(guid: string) {
    let s = this.scenarios.get(guid)
    if (s !== undefined) {
      //set all to false
      for (const scenario of this.scenarios.values()) {
        scenario.isBaseline = false
      }
      //set the one to true
      s.isBaseline = true
    }
  }

  setMaterialInfo(guid: string, info: MaterialInfo) {
    const mat = this.getMaterial(guid)
    if (mat.isEmpty()) {
      return
    }
    mat.updateMaterial(info)
    this.regenAssemblies()
  }

  setMemberInfo(guid: string, info: AMemberInfo){
    const member = this.getMember(guid)
    if(member){
      member.update(info)
      this.regenAssemblies()
    }
  }

  regenAssemblies() {
    for (const assembly of this.wallTypes.values()) {
      assembly.calculateGwpSF()
      assembly.regenGeometry()
    }
  }


  // Delete Methods --------------------------

  /* deleteMaterial(guid:string): boolean {
    const deleted = this.materials.delete(guid)
    this.regenAssemblies()
    return deleted
  } */

  deleteWallType(guid: string): boolean {
    return this.wallTypes.delete(guid);
  }

  deleteScenario(guid: string): boolean {
    const scenarios = Array.from(this.scenarios.values())
    //don't delete the only scenario
    if (scenarios.length < 2) {
      return false
    }
    let deleted = this.scenarios.delete(guid)
    // if there is no longer a baseline, set first scenario as baseline.
    if ( Array.from(this.scenarios.values()).filter(s => s.isBaseline === true).length === 0 ) {
      Array.from(this.scenarios.values())[0].isBaseline = true
    }
    return deleted
  }

  // Read/Write to Storage --------------------

  writeLocalStorage(){
    console.log('saving to local storage...')
    sessionStorage.setItem('appdata', JSON.stringify(this, null))
  }

  readLocalStorage(){
    const localData = sessionStorage.getItem('appdata')
    if(localData){
      try {
        this.readJsonFile(localData)
      } catch (error) {
        alert(error)
      }
    }
  }

  saveJsonFile() {
    console.log('saving file...')
    const datetime = getCurrentDateTimeAsString()
    const file = new File([JSON.stringify(this, null, 2)], `feather-${this.projectName}_${datetime}.json`, {type: "text/plain;charset=utf-8"})
    saveAs(file)
    this.writeLocalStorage()
  }

  readJsonFile(jsonText: string) {
    try {
      const data = JSON.parse(jsonText) as DataJSON
      this.wallTypes.clear()
      this.members.clear()
      this.materials.clear()
      this.scenarios.clear()
      const mats = data.materials as MaterialJSON[]
      if (mats) {
        mats.map( m => this.createMaterial(this.materialFromJSON(m)) )
      }
      const members = data.members as MemberJSON[]
      if (members) {
        members.map( m => this.createMember(this.memberFromJSON(m)) )
      }
      const assemblies = data.assemblies as AssemblyJSON[]
      if (assemblies) {
        assemblies.map( a => this.createWallType(this.assemblyFromJSON(a)) )
      }
      const scenarios = data.scenarios as ScenarioJSON[]
      if (scenarios) {
        scenarios.map( s => this.createScenarioFromJSON(s))
      }
      this.projectName = data.projectName
    } catch (error) {
      alert(error)
    }
  }

  //custom method to convert to json
  toJSON(): object {
    return {
      version: featherVersion,
      projectName: appdata.projectName,
      materials: appdata.getMaterialArray(),
      members: appdata.getMemberArray(),
      assemblies: appdata.getWallTypeArray(),
      scenarios: appdata.getScenarioArray(),
    }
  }

}

//global variable for appdata
export var appdata: AppData = new AppData()

//global variable for version#
export var featherVersion = 'v260416.0'

//global variable for news bar message
export var newsBarMessage = ''